import axios from "axios";
import { ElMessage } from "element-plus";
import { useUserStore } from "../stores/user";
import storage from "../utils/storage";
import { endsWith } from "lodash-es";
const service = axios.create({
  baseURL: import.meta.env.VITE_BASE_API, //import.meta.env.VITE_BASE_API
  timeout: 30000,
});

// 请求队列，用于存储待处理的请求
let queue = [];
// 标识是否正在刷新 token
let isRefreshing = false;

service.interceptors.request.use(
  (config) => {
    const user = useUserStore();
    if (user.token) {
      if (config.headers["Authorization"] !== null) {
        config.headers["Authorization"] = user.token;
      }
      // 忽略特定请求
      if (["eps", "refreshToken", "verifyToken"].some((e) => endsWith(config.url, e))) {
        return config;
      }
      // 判断 token 是否过期
      if (storage.isExpired("token")) {
        if (storage.isExpired("refreshToken")) {
          ElMessage.error("登录状态已失效，请重新登录");
          user.logout();
        } else {
          if (!isRefreshing) {
            isRefreshing = true;
            user
              .refreshToken()
              .then((res) => {
                queue.forEach((cb) => cb(res.data)); // 处理队列中的请求
                queue = [];
                isRefreshing = false;
              })
              .catch(() => {
                user.logout();
              });
          }
          return new Promise((resolve) => {
            queue.push((token) => {
              if (config.headers) {
                config.headers["Authorization"] = token; // 重新设置 token
              }
              resolve(config);
            });
          });
        }
      }
    }
    return config;
  },
  (error) => {
    ElMessage.error("请求配置错误");
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (res.message !== "success" || res.code !== 1000) {
      ElMessage.error(res.message || "请求错误");
      return Promise.reject(new Error(res.message || "请求错误"));
    }
    return res;
  },
  (error) => {
    const user = useUserStore();
    // 网络错误处理
    if (error.message === "Network Error") {
      ElMessage.error("网络连接失败，请检查网络设置或后端服务是否启动");
    } else if (error.code === "ECONNABORTED") {
      ElMessage.error("请求超时，请稍后重试");
    } else if (error.response.status === 401) {
      ElMessage.error("登录已过期，请重新登录");
      user.logout();
    } else if (error.response.status === 403) {
      ElMessage.error("登录失效或无权限访问~");
    } else {
      ElMessage.error(error.message || "请求失败");
    }
    return Promise.reject(error);
  }
);

export default service;
